<script lang="ts">
  import { Button } from '@shared/ui/buttons/button';
  import { Icon } from '@shared/ui/icon';
</script>

<svelte:head>
  <title>404 Error. Ukrainian Fund of Digitized Art (UFDA) – Page Not Found</title>
  <meta
    name="description"
    content="Oops! The page you’re looking for doesn’t exist. Return to the Ukrainian Fund of Digitized Art (UFDA) homepage to explore our artworks, artists, and more."
  />
</svelte:head>

<div class=" md:py-15 mx-auto flex max-w-[1176px] flex-col items-center justify-center py-24 lg:py-10">
  <div class="md:px-15 lg:mb-15 relative mb-10 w-full px-5 md:mb-12 lg:px-10 xl:px-0">
    <img
      src="/error.png"
      class="absolute left-1/2 top-1/2 h-auto max-h-full w-1/3 -translate-x-1/2 -translate-y-1/2 object-contain"
      alt="404 Error. pixel art of woman."
    />

    <Icon name="404" classes="w-full h-auto" />
  </div>

  <h1 class="mb-8 text-2xl font-medium lg:text-4xl">Sorry, this page doesn’t exist</h1>

  <Button href="/" hugged>Back To Home</Button>
</div>
